module.exports = __webpack_public_path__ + "static/img/101910.4dbd159e.png";